import { Component } from 'react';
import { connect } from 'react-redux';

import { convertStringToInteger } from 'common/helpers/numberHelper';
import { addCartItem } from 'redux/cart/actions';

import AddToCartButton from './AddToCartButton';
import ErrorMessage from './ErrorMessage';
import GiftCardItemData from './GiftCardItemData';
import Price from './Price';
import QuantityInput from './QuantityInput';
import VariantSelector from './VariantSelector';

class AddToCartEvent extends Component {
  constructor(props) {
    super(props);
    let quantity = 1;
    if (
      props.product.security &&
      props.product.security.availableTo === 'Allocation' &&
      props.product.allocations &&
      props.product.allocations[0]
    ) {
      quantity = props.product.allocations[0].minQuantity;
    }
    const itemData = {
      recipients: [{ name: '', email: '' }],
      acceptsTermsAndConditions: false,
      acceptsEmail: false
    };
    this.state = {
      quantity,
      itemData,
      errorMessage: null,
      selectedVariant: props.product.variants[0]
    };
  }

  submitForm = (e) => {
    const { props, state } = this;
    e.preventDefault();
    const { selectedVariant } = this.state;
    if (state.quantity === '' || Number.isNaN(state.quantity)) {
      this.setState({ errorMessage: 'Invalid Quantity' });
      return;
    }
    if (convertStringToInteger(state.quantity) < 1) {
      this.setState({ errorMessage: 'Invalid Quantity' });
      return;
    }
    // validate all data in events
    let errorMessage;
    for (let i = 0; i < state.quantity; i += 1) {
      if (
        !state.itemData.recipients[i] ||
        !state.itemData.recipients[i].name ||
        state.itemData.recipients[i].name === ''
      ) {
        errorMessage = 'Recipient Name Required';
      }
      if (
        !state.itemData.recipients[i] ||
        !state.itemData.recipients[i].email ||
        state.itemData.recipients[i].email === ''
      ) {
        errorMessage = 'Recipient Email Required';
      }
    }
    if (!state.itemData.acceptsTermsAndConditions) {
      errorMessage = 'Must Accept Terms & Conditions';
    }
    if (!state.itemData.acceptsEmail) {
      errorMessage = 'Must Accept Email Contact';
    }
    if (errorMessage) {
      this.setState({ errorMessage });
      return;
    }
    const item = {
      quantity: convertStringToInteger(state.quantity),
      sku: selectedVariant.sku,
      itemData: state.itemData
    };
    this.setState({ errorMessage: null });
    props.addCartItem(item, props.analytics);
  };

  handleItemDataChange = (itemData) => {
    this.setState({ itemData, errorMessage: null });
  };

  handleQuantityChange = (quantity) => {
    this.setState({ quantity, errorMessage: null });
  };

  handleVariantChange = (variantId) => {
    const { props } = this;
    const selectedVariant = props.product.variants.find(
      (variant) => variant.id === variantId
    );
    this.setState({ selectedVariant });
  };

  render() {
    const { product, hidePrice, settings, showVariantTitle } = this.props;
    const { selectedVariant, quantity, errorMessage, itemData } = this.state;
    return (
      <form
        action=""
        onSubmit={this.submitForm}
        className="c7-product__variant"
      >
        <Price
          variant={selectedVariant}
          hidePrice={hidePrice}
          settings={settings}
          showVariantTitle={showVariantTitle}
        />
        <VariantSelector
          product={product}
          selectedVariant={selectedVariant}
          settings={settings}
          onVariantChange={this.handleVariantChange}
        />
        <ErrorMessage errorMessage={errorMessage} />
        <>
          <div className="c7-product__variant__add-to-cart">
            Quantity:{' '}
            <QuantityInput
              quantity={quantity}
              onQuantityChange={this.handleQuantityChange}
              product={product}
              errorMessage={errorMessage}
            />
          </div>
          <div>
            <GiftCardItemData
              quantity={quantity}
              itemData={itemData}
              onItemDataChange={this.handleItemDataChange}
            />
          </div>
          <div className="c7-product__variant__add-to-cart">
            <AddToCartButton product={product} settings={settings} />
          </div>
        </>
      </form>
    );
  }
}

export default connect(null, { addCartItem })(AddToCartEvent);
